import http from "./http";

function getUsers(data) {
  return http.post(`user_get`, data);
}
function addUsers(data) {
  return http.post(`user_add`, data);
}
function updateUsers(data) {
  return http.post(`user_update`, data);
}
function deleteUsers(data) {
  return http.post(`user_delete`, data);
}

function getAgencyUser_list(data){
  return http.post(`Agency_UserList`,data);
}

function getAgencyProfileDetails(data){
  return http.post(`AgencyUserProfile`,data);
}

function getDistributerModelList(data){
  return http.post('DistributorModelList',data);
}

function getBatch_list(data){
  return http.post(`DistributorBatchList`,data);
}

const UsersService = {
  getUsers,
  addUsers,
  updateUsers,
  deleteUsers,
  getAgencyUser_list,
  getAgencyProfileDetails,
  getDistributerModelList,
  getBatch_list,
};

export default UsersService;
// ====================================
